import React, { useCallback, useState, useEffect } from 'react';

const PincodeTest = (props) => {

  const callback = useCallback(() => {
      props.setMain(true);
  }, [props]);

  const [screenId, setScreenId] = useState("APPL05");
  const [screenName, setScreenName] = useState("거래비밀번호");
  const [keypadCode, setKeypadCode] = useState("1");
  const [length, setLength] = useState(6);
  const [returnKeypadPid, setReturnKeypadPid] = useState("");
  const [returnKeypadCode, setReturnKeypadCode] = useState("");
  const [returnEnteredValue, setReturnEnteredValue] = useState("");
  const [code, setCode] = useState("");
  const [message, setMessage] = useState("");

  // clickPincodeEvent_Web 처리 (WEB > APP)
  const clickPincodeEventWeb = useCallback(() => {
    if (window.appInterface) {
      window.appInterface.clickPincodeEvent_Web(screenId, screenName, keypadCode, length);
    }
    else {
      alert("not found window.appInterface...");
    }
  }, [screenId, screenName, keypadCode, length]);

  // failEvent_Web 처리 (WEB > APP)
  const failEventWeb = useCallback(() => {
    if (window.appInterface) {
      window.appInterface.failEvent_Web(code, message);
    }
    else {
      alert("not found window.appInterface...");
    }
  }, [code, message]);

  // findPincode_Web 처리 (WEB > APP)
  const findPincodeWeb = useCallback(() => {
    if (window.appInterface) {
      window.appInterface.findPincode_Web();
    }
    else {
      alert("not found window.appInterface...");
    }
  }, []);

  // completedPincode_App 처리 (APP > WEB)
  const completedPincodeApp = useCallback((event) => {
    setReturnKeypadPid(event.detail.keypadPid);
    setReturnKeypadCode(event.detail.keypadCode);
    setReturnEnteredValue(event.detail.enteredValue);
    alert("completedPincode_App catch...");
  }, []);

  // APP이벤트 공통 수신처리 (APP > WEB)
  useEffect(() => {
    document.addEventListener("backpress", callback);
    document.addEventListener("pincode", completedPincodeApp);

    return () => {
      document.removeEventListener("backpress", callback);
      document.removeEventListener("pincode", completedPincodeApp);
    }
  }, [callback, completedPincodeApp]);

  return (
    <div id="container">
      <section className="contents">
        <div className="singUpWrapSub">
          <div className="txtWrap">
            <p className="mainTxt">clickPincodeEvent_Web</p>
          </div>
          <div className="conWrap mgt30">
            <div className="inputBoxWrapTy01" style={{overflow: "initial"}}>
              <div className="inputBoxTy01"> 
                <label className="mgb20">
                  <input type="text" value={screenId} onChange={(e) => setScreenId(e.target.value)} />
                  <span>screenId</span>
                </label>
              </div>
              <div className="inputBoxTy01"> 
                <label className="mgb20">
                  <input type="text" value={screenName} onChange={(e) => setScreenName(e.target.value)} />
                  <span>screenName</span>
                </label>
              </div>
            </div>
            <div className="inputBoxWrapTy01" style={{overflow: "initial"}}>
              <div className="inputBoxTy01 formSelectBoxTy02">
                <label className="mgb20" style={{margin: "0 0 45px", position: "relative", display: "inline-block", width: "100%"}}>
                  <select style={{padding: "10px 0"}} value={keypadCode} onChange={(e) => setKeypadCode(e.target.value)}>
                    <option value="1">[1] 거래비밀번호(6자리)</option>
                    <option value="2">[2] 카드비밀번호(4자리)</option>
                    <option value="3">[3] 카드비밀번호(2자리)</option>
                    <option value="4">[4] CVC(3자리)</option>
                  </select>
                  <span style={{opacity: ".5", transform: "scale(0.75) translateY(-80%) translateX(0px)", transformOrigin: "left", padding: "10px 0", fontSize: "18px", pointerEvents: "none", position: "absolute", left: "0", top: "0", transition: "0.2s", transitionTimingFunction: "cubic-bezier(0.25, 0.1, 0.25, 1)"}}>keypadCode</span>
                </label>
              </div>
              <div className="inputBoxTy01"> 
                <label className="mgb20">
                  <input type="number" value={length} onChange={(e) => setLength(e.target.value)} />
                  <span>length</span>
                </label>
              </div>
            </div>
            <div className="btnWrapTy01">
              <button type="button" className="btnPrimaryTy01" onClick={clickPincodeEventWeb}><span>clickPincodeEvent_Web Call</span></button>
            </div>
          </div>
        </div>
        <div className="singUpWrapSub">
          <div className="txtWrap">
            <p className="mainTxt">completedPincode_App</p>
          </div>
          <div className="conWrap mgt30">
            <div className="inputBoxTy01"> 
              <label className="mgb20">
                <input type="text" value={returnKeypadPid} readOnly />
                <span>keypadPid</span>
              </label>
            </div>
            <div className="inputBoxTy01"> 
              <label className="mgb20">
                <input type="text" value={returnKeypadCode} readOnly />
                <span>keypadCode</span>
              </label>
            </div>
            <div className="inputBoxTy01"> 
              <label className="mgb20">
                <input type="text" value={returnEnteredValue} readOnly />
                <span>enteredValue</span>
              </label>
            </div>
          </div>
        </div>
        <div className="singUpWrapSub">
          <div className="txtWrap">
            <p className="mainTxt">failEvent_Web</p>
          </div>
          <div className="conWrap mgt30">
            <div className="inputBoxTy01"> 
              <label className="mgb20">
                <input type="text" value={code} onChange={(e) => setCode(e.target.value)} />
                <span>code</span>
              </label>
            </div>
            <div className="inputBoxTy01"> 
              <label className="mgb20">
                <input type="text" value={message} onChange={(e) => setMessage(e.target.value)} />
                <span>message</span>
              </label>
            </div>
            <div className="btnWrapTy01">
              <button type="button" className="btnPrimaryTy01" onClick={failEventWeb}><span>failEvent_Web Call</span></button>
            </div>
          </div>
        </div>
        <div className="singUpWrapSub">
          <div className="txtWrap">
            <p className="mainTxt">findPincode_Web</p>
          </div>
          <div className="conWrap mgt30">
            <div className="btnWrapTy01 mgb60">
              <button type="button" className="btnPrimaryTy01" onClick={findPincodeWeb}><span>findPincode_Web Call</span></button>
            </div>
          </div>
        </div>
      </section>
      <div className="btnArea">
        <div className="btnWrapTy01">
          <button type="button" className="btnPrimaryTy01" onClick={callback}><span>메뉴복귀</span></button>
        </div>
      </div>
    </div>
  );
}

export default PincodeTest;